var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-right-presentation"},[(_vm.showControlActionHistories)?_c('ControlActionHistories',{attrs:{"is-mobile":true}}):_vm._e(),_c('div',[_c('SyncLoading')],1),_c('div',{staticClass:"-mt-1"},[_c('aha-button',{on:{"click":_vm.turnOffTabContent}},[_vm._v("\n      "+_vm._s(_vm.$i18nPresenter.t('Done'))+"\n    ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }